import React from 'react';
//import {IMG_URL} from '../config.js';
import {Link} from 'react-router-dom';
import {logout} from '../actions/UsuarioActions';
import {connect} from 'react-redux';

class Header extends React.Component {
  logout(){
    localStorage.clear();
    this.props.logout();
  }

  render(){
    return(
      <header className="main-header">
        <Link to="/" className="logo">
          <span className="logo-mini"><img src="/images/Logo alpha convites.png" alt="AU" style={{height: 30, width: 'auto', maxWidth: '100%'}}/></span>
          <span className="logo-lg"><img src="/images/Logo alpha convites.png" alt="Alpha Ultrapress" style={{height: 40, width: 'auto', verticalAlign: 'middle'}} /></span>
        </Link>
        <nav className="navbar navbar-static-top">
          <a className="sidebar-toggle" data-toggle="offcanvas" role="button">
            <span className="sr-only">Toggle navigation</span>
          </a>
          <div className="navbar-custom-menu">
            <ul className="nav navbar-nav">
              <li className="user user-menu">
                <a role="button" style={{cursor: "default"}}>
                  <span>{this.props.usuario.nome}</span>
                </a>
              </li>
              <li className="user user-menu">
                <a role="button" onClick={this.logout.bind(this)}>
                  <i style={{fontSize: 18}} className="fa fa-power-off"></i>
                </a>
              </li>
            </ul>
          </div>
        </nav>
      </header>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    usuario: state.usuario.autenticado
  };
};

export default connect(mapStateToProps, {logout})(Header);


// WEBPACK FOOTER //
// ./src/components/Header.js